<script setup>
import { useAutoAnimate } from '@formkit/auto-animate/vue';
import { inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Icons
import minus from '@i/minus.svg';
import plus from '@i/plus.svg';

// Components
import Button from '@/Components/Button/Button.vue';
import Icon from '@/Components/Images/Icon.vue';

const props = defineProps({
    title: String,
    faqs: Object,
    intended_url: String,
});

const [listContainer] = useAutoAnimate();
const current = ref(null);

const route = inject('route');
const { t } = useI18n();
</script>

<template>
    <div v-if="faqs && title">
        <div class="container py-16">
            <h2 class="" v-html="title" v-if="title"></h2>

            <ul ref="listContainer">
                <li class="py-6 border-b border-gray-light" v-for="(q, i) in faqs" :key="i" v-auto-animate>
                    <div class="flex items-center justify-between gap-6 cursor-pointer"
                        @click="current = current === q.id ? false : q.id">
                        <div class="max-w-full text-xs font-bold prose md:text-lg">
                            {{ q.question }}
                        </div>

                        <Icon :icon="minus" class="w-5 h-5 rounded-full bg-gray-light shrink-0" v-if="q.id === current"
                            :alt="t('minus icon')" />
                        <Icon :icon="plus" class="w-5 h-5 rounded-full bg-gray-light shrink-0" :alt="t('plus icon')"
                            v-else />
                    </div>

                    <p class="my-4 text-xs answer md:text-base text-gray-medium" v-if="q.id === current"
                        v-html="t(q.answer)" />
                </li>
            </ul>

            <div class="mt-10">
                <Button :label="$t('See all faqs')" :href="intended_url" class="relative z-30 w-auto mt-8" />
            </div>
        </div>
    </div>
</template>
